// firebase.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// 🔴 IMPORTANT: Replace XXXX with real values from Firebase console
const firebaseConfig = {
  apiKey: "AIzaSyBtclU2Kl7q5-3y_MfBHYb1l2RtphELdw8",
  authDomain: "box-cricket-app-c8999.firebaseapp.com",
  projectId: "box-cricket-app-c8999",
  storageBucket: "box-cricket-app-c8999.appspot.com",
  messagingSenderId: "988915073687",
  appId: "1:988915073687:web:0e6f8e79c2b9c595bf9fd2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);
export const auth = getAuth(app);